<template>
  <div class="player">
    <div class="metadata">{{ data.label }}</div>
    
    <div class="ratio ratio-16x9" v-if="type === 'twitch'" ref="twitch-container"></div>

    <div class="ratio ratio-16x9" v-else-if="type === 'youtube'" ref="twitch-container">
      <iframe width="100%" height="100%" :src="`https://www.youtube-nocookie.com/embed/${target}?autoplay=1&modestbranding=1&showinfo=0&rel=0&disablekb=1`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>

    <div class="ratio ratio-16x9" v-else-if="type === 'mux'">
      <div v-if="!muxLoad" class="d-flex align-items-center justify-content-center loadingMux">Loading...</div>
      <div v-if="muxLoad && !muxToken" class="d-flex align-items-center justify-content-center loadingMux">Failed to load stream.</div>
      <mux-player v-if="muxLoad && muxToken" :playback-id="target" :playback-token="muxToken" autoplay controls :muted="muted" stream-type="live" style="--pip-button: none;" />
    </div>
    
  </div>
</template>
<script>
/* global Twitch */
import "@mux/mux-player";

import { api, TwitchParent } from '../api';
import { EventBus } from "../EventBus";

export default {
  props: ['data', 'muted'],
  data: () => ({
    playerContext: null,
    muxLoad: false,
    muxToken: null,
  }),
  computed: {
    type(){
      return this.data?.type;
    },
    target(){
      return this.data?.target;
    },
  },
  watch: {
    muted: function(){ this.mutedHandler(); }
  },
  methods: {
    mutedHandler(){
      if(!this.playerContext) return;
      if(this.type === 'twitch') this.playerContext.setMuted(this.muted);
    },
    async initMuxPlayer(){
      if(this.playerContext) return;
      try {
        const { data } = await api.get(`/mux_sign/${this.target}`);
        if(!data.result) return;
        this.muxToken = data.token;
      } catch (error) {
        EventBus.$emit('error', 'Connection failed', error.toString());
      } finally {
        this.muxLoad = true;
      }
    },
    initTwitchPlayer(){
      if(this.playerContext) return;

      this.playerContext = new Twitch.Embed(this.$refs['twitch-container'], {
        width: '100%',
        height: '100%',
        channel: this.target,
        layout: 'video',
        muted: this.muted,
        autoplay: true,
        parent: [ TwitchParent ]
      });

      this.playerContext.addEventHandler()
    },
  },
  async mounted(){
    if(this.type === 'twitch') this.initTwitchPlayer();
    if(this.type === 'mux') await this.initMuxPlayer();
    this.mutedHandler();
  }
}
</script>
<style scoped>
.player{
  /* flex: 1 0 50%; */
  position: relative;
  width: 100%;
  border-radius: 4px;
  border: 2px solid rgba(255,255,255,0);
  transition: border 266ms ease;
  overflow: hidden;
}
.player > .metadata{
  position: absolute;
  top: -50px;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 100;
  background-color: rgba(75, 75, 75, 0.7);
  transition: top 266ms ease;
  padding: 0 1rem;
  backdrop-filter: blur(4px);
}
.player:hover{
  border: 2px solid rgba(255,255,255,0.4);
}
.player:hover > .metadata{
  top: 0px;
}
.loadingMux{
  background-color: rgb(22, 22, 22);
}
</style>